import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { EmailTagsComponent } from '../email-tags/email-tags.component';
import { MeetingService, AmplitudeService, NotificationService } from '@core/services';

@Component({
    standalone: true,
    selector: 'app-email-modal',
    imports: [CommonModule, FormsModule, EmailTagsComponent],
    templateUrl: './email-modal.component.html'
})
export class EmailModalComponent {

    @Input() meetingBotId: string = '';
    @Input() opportunityId: string = '';
    @Input() emails: string[] = [];

    show = false;
    isValid = false;
    isSending = false;

    constructor(
        private readonly _meetingService: MeetingService,
        private readonly _amplitudeService: AmplitudeService,
        private readonly _notificationService: NotificationService
    ) { }

    open(): void {
        this.show = true;
    }

    close(): void {
        this.show = false;
    }

    cancel(): void {
        this.close();
    }

    emailList(data: { emails: string[]; invalid: boolean }): void {
        this.emails = data.emails;
        this.isValid = !data.invalid;
    }

    sendEmail(): void {
        if (this.isSending || !this.isValid) {
            return;
        }

        this.isSending = true;
        this._amplitudeService.trackEvent('opportunity_detail_send_email', {
            opportunity_id: this.opportunityId
        });

        this._meetingService.sendEmail(this.meetingBotId, this.emails).subscribe({
            next: () => {
                this._notificationService.notifySuccess('Meeting summary email sent successfully');
                this.isSending = false;
                this.close();
            },
            error: (error) => {
                const message = error?.error?.message || error?.message || 'Failed to send meeting summary email';
                this._notificationService.notifyError(message);
                this.isSending = false;
            }
        });
    }
}
